import { useContext } from 'react';
import { PreferencesEditorContext, } from './PreferencesEditorContext';
export var usePreferencesEditor = function () {
    return useContext(PreferencesEditorContext);
};
//# sourceMappingURL=usePreferencesEditor.js.map